export default __webpack_public_path__ + "static/media/Search-khaki.7855d7b2.svg";